import { ITournamentMatchShotData } from 'twain-sport-fe-mono/interfaces';

export const getGameStartAudio = (
    leftShot: ITournamentMatchShotData,
    rightShot: ITournamentMatchShotData,
): string => {
    if (leftShot.isSuccessful && rightShot.isSuccessful) {
        return '1';
    }

    if (!leftShot.isSuccessful && !rightShot.isSuccessful) {
        return '2';
    }

    const randomSound = Math.floor(Math.random() * 2);
    if (leftShot.isSuccessful && !rightShot.isSuccessful) {
        return randomSound ? '3' : '5';
    }

    return randomSound ? '4' : '6';
};
